
import Vue from 'vue'
import ManualItem from '../manual-item/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'ManualItemList',
  components: {
    ManualItem
  },
  mixins: [staticBlockMixin],
  props: {
    noBorder: {
      type: Boolean,
      required: true,
      default: false
    }
  }
})
